import { Autocomplete, Box, TextField, Typography } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";

const CountrySelect = ({
  type = "country",
  value,
  error,
  onBlur = () => {},
  onChange,
  disabled = false,
  textfieldProps,
}) => {
  const { Common, Translation } = useSelector((state) => ({
    Common: state.Common.common,
    Translation: state.Translation.translation?.Common || {},
  }));
  const countriesList = Common?.Country || [];

  const selectedOption = React.useMemo(() => {
    return countriesList.find((item) => item.ID === value || item.DialCode === value) || null;
  }, [countriesList, value]);

  return (
    <Autocomplete
      sx={{
        minWidth: type == "code" ? "100px" : "auto",
        // "& .MuiOutlinedInput-root": { paddingRight: "0px !important" },
        // direction: 'ltr'
      }}
      options={countriesList}
      autoHighlight
      getOptionLabel={(option) =>
        type == "code" ? `${option?.DialCode}` : option.Value
      }
      clearIcon={false}
      value={selectedOption}
      onBlur={onBlur}
      onChange={(value, newVal) => onChange(newVal)}
      disabled={disabled}
      renderOption={(props, option) => {
        const { key, ...optionProps } = props;
        return (
          <Box
            key={`${key}${option.code}`}
            component="li"
            sx={(theme) => theme.direction === "rtl" ? { direction: 'rtl !important', "& > img": { ml: 2, flexShrink: 0 } } :
            { direction: 'ltr !important', "& > img": { mr: 2, flexShrink: 0 } }
          }
            {...optionProps}
          >
            <img
              loading="lazy"
              width="20"
              srcSet={`https://flagcdn.com/w40/${option.CountryCode.toLowerCase()}.png 2x`}
              src={`https://flagcdn.com/w20/${option.CountryCode.toLowerCase()}.png`}
              alt=""
            />
            {type == "country" ? option.Value : option.DialCode}
          </Box>
        );
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          error={Boolean(error)}
          helperText={error}
          name="country"
          placeholder={type == "code" ? "+965" : Translation?.SelectCountry}
          {...textfieldProps}
           sx={(theme) => ({direction: `${theme.direction} !important`})}
          slotProps={{
            htmlInput: {
              ...params.inputProps,
              autoComplete: "new-password",
            },
          }}
        />
      )}
    />
  );
};

export default React.memo(CountrySelect);
